import { render, staticRenderFns } from "./moblie.vue?vue&type=template&id=fee2e698&scoped=true&"
import script from "./moblie.vue?vue&type=script&lang=js&"
export * from "./moblie.vue?vue&type=script&lang=js&"
import style0 from "./moblie.vue?vue&type=style&index=0&id=fee2e698&prod&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fee2e698",
  null
  
)

export default component.exports